import { isGlobalPath, dispatch } from './marker.js';
import { traverse } from './tree/traverse.js';
import { graft, detach, replace } from './tree/mutate.js';
import { isPrimitive } from '../utils/isPrimitive.js';
import { clone } from '../utils/clone.js';

function spread(value) {
  if (Array.isArray(value)) {
    return [...value];
  }
  if (typeof value === 'object' && value !== null) {
    return {...value};
  }
  return value;
}

export function get(state, marker, cb) {
  let shouldCallCallback = false;
  try {
    return dispatch(marker, {
      global: () => {
        shouldCallCallback = true;
        return state;
      },
      path: ({path}) => {
        shouldCallCallback = true;
        return traverse(state, path);
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (shouldCallCallback && cb) {
      cb(marker);
    }
  }
}

export function set(state, marker, value, method, cb) {
  let from;
  let shouldCallCallback = false;
  
  try {
  return dispatch(marker, {
      global: () => {
        from = {...state};
        state = replace(state, value);
        shouldCallCallback = true;
        return value;
      },
      path: ({path}) => {
        from = spread(traverse(state, path));
        graft(state, path, value);
        shouldCallCallback = true;
        return value;
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (shouldCallCallback && cb) {
      cb(marker, method, value, from);
    }
  }
}

export function remove(state, marker, method, cb) {
  let from;
  let shouldCallCallback = false;
  try {
  return dispatch(marker, {
      global: () => {
        from = state;
        state = replace(state, {});
        shouldCallCallback = true;
        return from;
      },
      path: ({path}) => { 
        from = detach(state, path);
        shouldCallCallback = true;
        return from;
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (cb) {
      cb(marker, method, undefined, from);
    }
  }
}

export function update(state, marker, fn, method, cb) {
  let from, to;
  let shouldCallCallback = false;
  try {
  return dispatch(marker, {
      global: () => {
        from = state;
        to = fn(state);
        state = replace(state, to);
        shouldCallCallback = true;
        return to;
      },
      path: ({ path }) => {
        from = isGlobalPath(path) ? state : traverse(state, path);
        const clonePrev = isPrimitive(from) ? from : clone(from);
        to = fn(clonePrev);
        graft(state, path, to);
        shouldCallCallback = true;
        return to;
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (shouldCallCallback && cb) {
      cb(marker, method, to, from);
    }
  }
}